import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
//import { Http } from "@angular/http";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { Router } from "@angular/router";
import { HttpServiceAgentResource } from "../../../services/iap-http.service";
import { CustomBox, DialogComponent } from "../../../../shared/components/dialog/dialog.component";
import { Helper } from "../../../../shared/common/helper";
import { AuthenticationService } from "../../../../shared/auth/auth.service";
import { IAgentResource } from "src/app/iap/models/applicant.model";
import { MatCard, MatCardContent } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { MatFormField } from "@angular/material/form-field";
import { CommonModule } from "@angular/common";
import { MatInputModule } from "@angular/material/input";

@Component({
    selector: "app-iap-resources",
    imports: [
        CommonModule,
        MatCard,
        MatCardContent,
        MatFormField,
        MatInputModule,
        MatPaginator,
        MatTableModule,
        MatIcon
    ],
    templateUrl: "./resources-for-agencies.component.html",
    styleUrls: ["./resources-for-agencies.component.scss"]
})
export class ResourcesForAgenciesComponent implements OnInit {
  agentResources: IAgentResource[];

  public centered: boolean;
  public disabled: boolean;
  public unbounded: boolean;
  public radius: number;
  public color: string;
  public isPageReadOnly: boolean;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = ["DisplayName"];
  dataSource!: MatTableDataSource<any>;
  ELEMENT_DATA: IAgentResource[];

  constructor(
    private router: Router,
    private httpServiceAgentResource: HttpServiceAgentResource,
    //private http: Http,
    private authService: AuthenticationService,
    private dialog: MatDialog
  ) {
    this.centered = true;
    this.disabled = false;
    this.unbounded = false;
    this.radius = 25;
    this.color = "#da291c";

    this.agentResources = [];
    this.ELEMENT_DATA = [];
    this.isPageReadOnly = this.authService.isPageReadOnly("Resources");
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement)?.value
      .trim()
      .toLowerCase();
    this.dataSource.filter = filterValue;
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.pageSize = 5;
    } else {
      console.warn("Paginator not yet initialized");
    }
  }

  public ngOnInit() {
    this.httpServiceAgentResource
      .getAgentResourceRequest("resources")
      .subscribe(result => {
        this.agentResources = result;

        this.ELEMENT_DATA = result;
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      });
  }

  public NavigateToRequestForMaterial() {
    this.router.navigate(["iap/resources/requestformaterial"]);
  }

  public IsFile(resource: any): boolean {
    return resource.SourceID === 2;
  }

  public IsLink(resource: any): boolean {
    return resource.Link !== "";
  }

  DisplayErrorMessage(dialog: MatDialog, dialogHeading: string, messages: string, no: string, yes: string) {
    const resDialog = new CustomBox(dialogHeading, messages, no, yes);

    const dialogRef = dialog.open(DialogComponent, {
      maxWidth: "600px",
      data: resDialog
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        setTimeout(() => {
          window.location.reload();
        }, 200);
      }
    });
  }

  public DownloadFile(id: number, name: string): boolean {
    return this.httpServiceAgentResource
      .checkIfFileExists("resources/checkIfFileExists", id.toString())
      .subscribe((response: any) => {
        if (response === true) {
          this.DisplayFile(id, name);
        } else {
          this.DisplayErrorMessage(
            this.dialog,
            "Informational Message",
            "The file does not exists on the server's storage.",
            "Hidden",
            "Close"
          );

          console.log("File does not exists in the blob's storage: " + name);
        }
      });
  }

  public DisplayFile(id: number, name: string): any {
    console.log(
      "DownloadFile method has been called for the file named: " + id.toString()
    );

    return this.httpServiceAgentResource
      .downloadFile("resources/downloadFile", id.toString())
      .subscribe((response: any) => {
        var fileExtension = name.split(".").pop();
        if (fileExtension) {
          let downloadedFile = new File([response], name, {
            type: response.type
          });

          var contentType = Helper.GetContentType(fileExtension);

          var blob = new Blob([downloadedFile], {
            type: contentType
          });

          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = name;
          document.body.appendChild(link);

          setTimeout(() => window.open(link.href), 500);
        }
      });
  }
}
